import { Action, createReducer, on } from '@ngrx/store';
import { fromProductStartingAgesAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const productStartingAgesFeatureKey = 'productStartingAges';

export interface ProductStartingAgesState {
  productStartingAgesResponse: IStaticDataResponse[];
  productStartingAgesFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: ProductStartingAgesState = {
  productStartingAgesFailure: undefined,
  productStartingAgesResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromProductStartingAgesAction.loadProductStartingAges, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromProductStartingAgesAction.loadProductStartingAgesSuccess, (state, action) => ({
    ...state,
    productStartingAgesResponse: action.response
  })),

  on(fromProductStartingAgesAction.loadProductStartingAgesFailure, (state, action) => ({
    ...state,
    productStartingAgesFailure: action.error
  }))
);

export const getProductStartingAgesResponse = (state: ProductStartingAgesState) => state.productStartingAgesResponse;
export const getProductStartingAgesFailure = (state: ProductStartingAgesState) => state.productStartingAgesFailure;
export const getProductStartingAgesIsLoaded = (state: ProductStartingAgesState) => state.loaded;
